<template>
  <div class="navbar-wrapper">
    <!-- Logo - Arriba izquierda -->
    <div
      @click="scrollToSection('home')"
      class="navbar__brand"
      :class="{ 'navbar__brand--active': activeSection === 'home' }"
    >
      <span class="navbar__brand-name">jl.</span>
    </div>

    <!-- Nav - Links centrados a la derecha -->
    <nav class="navbar" :class="{ 'navbar--dimmed': activeSection === 'footer' }">
      <ul class="navbar__links">
        <li>
          <a
            @click="scrollToSection('about')"
            class="navbar__link"
            :class="{ 'navbar__link--active': activeSection === 'about' }"
            >{{ $t('common.navbar.about') }}
            <!--  -->
            <svg
              id="element-about"
              class="aaa navbar__link-svg"
              width="56"
              height="19"
              viewBox="0 0 56 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.7942 1.5H9.40592C5.0396 1.5 1.5 5.0396 1.5 9.40592C1.5 13.7722 5.0396 17.3118 9.40593 17.3118H54.0986"
                stroke="#7C3AED"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
          </a>
        </li>
        <li>
          <a
            @click="scrollToSection('whatido')"
            class="navbar__link"
            :class="{ 'navbar__link--active': activeSection === 'whatido' }"
            >{{ $t('common.navbar.whatido') }}
            <!--  -->
            <svg
              id="element-whatido"
              class="asbbb navbar__link-svg navbar__link-svg--right"
              width="79"
              height="39"
              viewBox="0 0 79 39"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M59.584 1.5C69.2969 1.5 77.332 9.37381 77.332 19.0866C77.332 28.7995 69.4582 36.6733 59.7454 36.6733H1.49971"
                stroke="#7C3AED"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
          </a>
        </li>
        <li>
          <a
            @click="scrollToSection('works')"
            class="navbar__link"
            :class="{ 'navbar__link--active': activeSection === 'works' }"
            >{{ $t('common.navbar.works') }}
            <!--  -->
            <svg
              id="element-works"
              class="navbar__link-svg"
              width="79"
              height="38"
              viewBox="0 0 79 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.6026 1.5C9.1571 1.5 1.5 9.23739 1.5 18.6829C1.5 28.2175 9.22934 36.0279 18.764 36.0279H76.687"
                stroke="#7C3AED"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
          </a>
        </li>
        <li>
          <a
            @click="scrollToSection('journey')"
            class="navbar__link"
            :class="{ 'navbar__link--active': activeSection === 'journey' }"
            >{{ $t('common.navbar.journey') }}
            <!--  -->
            <svg
              id="element-journey"
              class="aaa navbar__link-svg navbar__link-svg--right"
              width="69"
              height="39"
              viewBox="0 0 69 39"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M50.5486 1.5C59.6377 1.5 67.0059 8.86815 67.0059 17.9572V19.0866C67.0059 28.7995 59.132 36.6733 49.4192 36.6733H1.49964"
                stroke="#7C3AED"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
          </a>
        </li>
        <li>
          <a
            @click="scrollToSection('footer')"
            class="navbar__link"
            :class="{ 'navbar__link--active': activeSection === 'footer' }"
            >{{ $t('common.navbar.contact') }}
            <!--  -->
            <svg
              id="element-contact"
              class="navbar__link-svg"
              width="72"
              height="39"
              viewBox="0 0 72 39"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.6026 1.5C9.1571 1.5 1.5 9.1571 1.5 18.6026V19.0866C1.5 28.7995 9.37381 36.6733 19.0866 36.6733H70.2331"
                stroke="#7C3AED"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
          </a>
        </li>
        <li v-if="false">
          <button @click="goToResume" type="button" class="navbar__button">
            <FileStarIcon class="navbar__icon" />
            <span>{{ $t('common.navbar.resume') }}</span>
          </button>
        </li>
      </ul>
    </nav>

    <!-- Decorative detail - Bottom right corner -->
    <svg
      class="navbar__corner-detail --top"
      width="327"
      height="303"
      viewBox="0 0 327 303"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      draggable="false"
    >
      <path
        d="M303.368 -6.10352e-05C295.768 2.2001 288.176 4.42581 280.591 6.67706C271.827 9.27878 263.072 11.9146 254.329 14.5846C248.397 16.3924 242.839 19.4321 238.113 23.4549C232.978 27.815 228.817 33.3161 226.022 39.4457C223.914 44.0595 221.806 48.6735 219.699 53.2877C213.977 66.013 201.963 75.6666 188.296 78.5131C144.259 87.9532 100.227 97.4156 56.1946 106.878C46.8616 108.861 38.2051 113.852 31.808 120.919C25.7459 127.569 21.7196 136.038 20.3949 144.931C14.7343 182.434 9.13953 219.946 3.52008 257.455C2.34802 265.279 1.17487 273.102 -0.000152588 280.925C-0.000152588 280.925 -0.000152588 280.925 -0.000152588 280.925C1.22025 273.109 2.44254 265.293 3.66592 257.478C9.53131 220.006 15.4214 182.539 21.2456 145.061C22.5842 136.34 26.56 128.059 32.5125 121.561C38.7949 114.655 47.2773 109.795 56.4083 107.879C100.464 98.5262 144.52 89.1738 188.571 79.7993C202.643 76.8908 215.033 66.9631 220.939 53.8546C223.05 49.242 225.16 44.6293 227.271 40.0164C229.986 34.0701 234.023 28.7345 239.005 24.5042C243.591 20.6016 248.961 17.6264 254.709 15.8081C263.424 13.0468 272.129 10.2514 280.823 7.42184C288.346 4.97342 295.861 2.49945 303.368 -6.10352e-05Z"
        fill="currentColor"
      />
    </svg>

    <svg
      class="navbar__corner-detail"
      width="327"
      height="303"
      viewBox="0 0 327 303"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      draggable="false"
    >
      <path
        d="M0 302.452C8.18258 300.083 16.3566 297.687 24.5221 295.263C33.9586 292.462 43.3837 289.624 52.7974 286.75C59.1833 284.803 65.1671 281.531 70.2557 277.2C75.7846 272.505 80.2634 266.583 83.2729 259.984C85.5425 255.016 87.8118 250.049 90.0807 245.081C96.2411 231.38 109.175 220.987 123.89 217.922C171.301 207.759 218.708 197.572 266.114 187.384C276.162 185.249 285.482 179.876 292.369 172.267C298.896 165.108 303.231 155.989 304.657 146.415C310.751 106.039 316.775 65.6514 322.825 25.2681C324.087 16.8452 325.35 8.42241 326.615 0C325.301 8.41493 323.985 16.8296 322.668 25.244C316.353 65.5868 310.012 105.925 303.741 146.275C302.3 155.664 298.019 164.58 291.611 171.576C284.847 179.011 275.715 184.243 265.884 186.307C218.452 196.376 171.02 206.445 123.594 216.538C108.443 219.669 95.1042 230.357 88.7456 244.47C86.4729 249.436 84.2007 254.403 81.9288 259.369C79.0057 265.771 74.6595 271.515 69.2953 276.07C64.358 280.272 58.5761 283.475 52.3876 285.432C43.0045 288.405 33.6329 291.415 24.2726 294.461C16.1732 297.097 8.08232 299.761 0 302.452Z"
        fill="currentColor"
      />
    </svg>

    <!-- Acciones - Abajo derecha (fuera del nav) -->
    <div class="navbar__actions">
      <button
        type="button"
        @click="handleThemeToggle"
        class="navbar__icon-btn navbar__icon-btn--round"
        :title="`${$t('common.navbar.theme')}: ${currentModeLabel}`"
      >
        <component :is="getThemeIcon()" class="theme-icon navbar__icon" />
      </button>

      <LanguageSwitcher />
    </div>

    <!-- Mobile Menu Button -->
    <button
      type="button"
      @click="toggleMenu"
      class="navbar__mobile-toggle"
      title="Menu"
      aria-label="Menu"
    >
      <component :is="isMenuOpen ? Cancel01Icon : Menu01Icon" class="navbar__icon--large" />
    </button>

    <!-- Mobile Menu Overlay -->
    <div v-show="isMenuOpen" class="mobile-menu">
      <ul class="mobile-menu__links">
        <li class="mobile-link">
          <a
            @click="(scrollToSection('about'), toggleMenu())"
            class="mobile-menu__link"
            :class="{ 'mobile-menu__link--active': activeSection === 'about' }"
          >
            {{ $t('common.navbar.about') }}
          </a>
        </li>
        <li class="mobile-link">
          <a
            @click="(scrollToSection('whatido'), toggleMenu())"
            class="mobile-menu__link"
            :class="{ 'mobile-menu__link--active': activeSection === 'whatido' }"
          >
            {{ $t('common.navbar.whatido') }}
          </a>
        </li>
        <li class="mobile-link">
          <a
            @click="(scrollToSection('works'), toggleMenu())"
            class="mobile-menu__link"
            :class="{ 'mobile-menu__link--active': activeSection === 'works' }"
          >
            {{ $t('common.navbar.works') }}
          </a>
        </li>
        <li class="mobile-link">
          <a
            @click="(scrollToSection('journey'), toggleMenu())"
            class="mobile-menu__link"
            :class="{ 'mobile-menu__link--active': activeSection === 'journey' }"
          >
            {{ $t('common.navbar.journey') }}
          </a>
        </li>
        <li class="mobile-link">
          <a
            @click="(scrollToSection('footer'), toggleMenu())"
            class="mobile-menu__link"
            :class="{ 'mobile-menu__link--active': activeSection === 'footer' }"
          >
            {{ $t('common.navbar.contact') }}
          </a>
        </li>
      </ul>

      <div class="mobile-link mobile-menu__actions">
        <!-- Theme Toggle -->
        <button
          type="button"
          @click="handleThemeToggle"
          class="navbar__icon-btn navbar__icon-btn--round navbar__icon-btn--large"
          :title="`${$t('common.navbar.theme')}: ${currentModeLabel}`"
        >
          <component :is="getThemeIcon()" class="theme-icon navbar__icon--large" />
        </button>

        <!-- Language Buttons (Mobile) -->
        <div class="mobile-lang-switcher">
          <button
            v-for="lang in availableLanguages"
            :key="lang.code"
            @click="setLocale(lang.code)"
            class="mobile-lang-btn"
            :class="{ 'mobile-lang-btn--active': locale === lang.code.toLowerCase() }"
          >
            {{ lang.code }}
          </button>
        </div>
      </div>

      <!-- Footer Info -->
      <div class="mobile-menu__footer">
        <!--        <p class="mobile-menu__copy">designed & built by Juan Lias</p>-->
      </div>
    </div>

    <!-- Flash transition overlay for far-section navigation (3+ hops) -->
    <div class="navbar__flash-overlay" />
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, nextTick, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import {
  SunglassesIcon,
  MoonEclipseIcon,
  Menu01Icon,
  Cancel01Icon,
  FileStarIcon,
  StarCircleIcon,
} from 'hugeicons-vue'
import gsap from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { useTheme } from '@/composables/useTheme'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'

gsap.registerPlugin(ScrollToPlugin)

const route = useRoute()
const router = useRouter()
const { locale } = useI18n()
const { themeMode, currentModeLabel, cycleTheme, THEME_MODES } = useTheme()

const activeSection = ref('home')
const isMenuOpen = ref(false)
const isFlashTransitioning = ref(false)
let sparkContainer = null
const prefersReducedMotion =
  typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches

const availableLanguages = [
  { code: 'ES', label: 'Español' },
  { code: 'EN', label: 'English' },
  { code: 'PT', label: 'Português' },
]

const setLocale = (code) => {
  locale.value = code.toLowerCase()
  localStorage.setItem('user-locale', locale.value)
}

// Navegar a la página de resume
const goToResume = () => {
  router.push('/resume')
}

// Computed para determinar qué icono mostrar
const getThemeIcon = () => {
  switch (themeMode.value) {
    case THEME_MODES.AUTO:
      return StarCircleIcon
    case THEME_MODES.LIGHT:
      return SunglassesIcon
    case THEME_MODES.DARK:
      return MoonEclipseIcon
    default:
      return StarCircleIcon
  }
}

// Función para crear chispas mágicas
const createMagicSparks = (clickX, clickY) => {
  if (prefersReducedMotion) return

  if (!sparkContainer) {
    sparkContainer = document.createElement('div')
    sparkContainer.className = 'fixed inset-0 pointer-events-none z-[9999]'
    sparkContainer.style.cssText =
      'position: fixed; top: 0; left: 0; right: 0; bottom: 0; pointer-events: none; z-index: 9999;'
    document.body.appendChild(sparkContainer)
  }

  // Colores mágicos para el tema (púrpura eléctrico)
  const sparkConfig = {
    gradient: 'linear-gradient(45deg, #4c00ff 0%, #ffffff 50%, #BFBFBF 100%)',
    boxShadow: '0 0 6px #4c00ff, 0 0 12px rgba(76, 0, 255, 0.5), 0 0 18px rgba(76, 0, 255, 0.3)',
  }

  const sparkCount = 10

  for (let i = 0; i < sparkCount; i++) {
    const spark = document.createElement('div')
    spark.style.cssText = `
      position: absolute;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      pointer-events: none;
      background: ${sparkConfig.gradient};
      box-shadow: ${sparkConfig.boxShadow};
      left: ${clickX}px;
      top: ${clickY}px;
      transform: translate(-50%, -50%) scale(0);
      opacity: 0;
    `

    sparkContainer.appendChild(spark)

    const angle = (i / sparkCount) * Math.PI * 2 + (Math.random() - 0.5) * 0.5
    const distance = 30 + Math.random() * 60
    const endX = Math.cos(angle) * distance
    const endY = Math.sin(angle) * distance

    gsap
      .timeline({
        onComplete: () => {
          if (spark.parentNode) {
            spark.remove()
          }
        },
      })
      .to(spark, {
        duration: 0.1,
        scale: 1,
        opacity: 1,
        ease: 'power2.out',
      })
      .to(
        spark,
        {
          duration: 0.5,
          x: endX,
          y: endY,
          scale: 0.3,
          rotation: Math.random() * 360,
          ease: 'power2.out',
        },
        0
      )
      .to(
        spark,
        {
          duration: 0.25,
          opacity: 0,
          ease: 'power2.in',
        },
        0.25
      )
  }
}

// Función para toggle del tema con animación
const handleThemeToggle = (event) => {
  const btn = event.currentTarget
  const icon = btn.querySelector('.theme-icon')

  // Obtener posición del click para las chispas
  const rect = btn.getBoundingClientRect()
  const clickX = rect.left + rect.width / 2
  const clickY = rect.top + rect.height / 2

  // Animate out icon
  gsap.to(icon, {
    rotation: 90,
    scale: 0,
    opacity: 0,
    duration: 0.3,
    ease: 'back.in(1.7)',
    onComplete: () => {
      // Cycle to next theme
      cycleTheme()

      // Esperar a que el DOM se actualice, luego crear chispas y animar el nuevo icono
      setTimeout(() => {
        // Crear efecto de chispas mágicas después del cambio de tema
        createMagicSparks(clickX, clickY)

        // Efecto de pulso en el botón
        gsap
          .timeline()
          .to(btn, {
            duration: 0.1,
            scale: 0.9,
            ease: 'power2.out',
          })
          .to(btn, {
            duration: 0.2,
            scale: 1.1,
            ease: 'power2.out',
          })
          .to(btn, {
            duration: 0.15,
            scale: 1,
            ease: 'power2.out',
          })

        const newIcon = btn.querySelector('.theme-icon')
        // Animate in
        gsap.fromTo(
          newIcon,
          { rotation: -90, scale: 0, opacity: 0 },
          { rotation: 0, scale: 1, opacity: 1, duration: 0.4, ease: 'back.out(1.7)' }
        )
      }, 0)
    },
  })
}

// Función para toggle del menú móvil
const toggleMenu = () => {
  if (!isMenuOpen.value) {
    // Open Menu
    isMenuOpen.value = true

    // Prevent scrolling
    document.body.style.overflow = 'hidden'

    // Animate Overlay
    gsap.fromTo(
      '.mobile-menu',
      { clipPath: 'circle(0% at 100% 0%)' },
      { clipPath: 'circle(150% at 100% 0%)', duration: 0.8, ease: 'power3.inOut' }
    )

    // Animate Links
    gsap.fromTo(
      '.mobile-link',
      { y: 50, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.5, stagger: 0.1, delay: 0.4, ease: 'power3.out' }
    )
  } else {
    // Close Menu
    gsap.to('.mobile-menu', {
      clipPath: 'circle(0% at 100% 0%)',
      duration: 0.8,
      ease: 'power3.inOut',
      onComplete: () => {
        isMenuOpen.value = false
        document.body.style.overflow = ''
      },
    })
  }
}

// Secciones en orden de aparición (mismo orden que el nav)
const sectionsOrder = ['home', 'about', 'whatido', 'works', 'journey', 'footer']

// Flash transition para secciones lejanas (3+ hops)
const flashToSection = (sectionId, element) => {
  gsap.killTweensOf(window)

  const elementPosition = element.offsetTop

  isFlashTransitioning.value = true

  gsap
    .timeline()
    .to('.navbar__flash-overlay', {
      opacity: 1,
      duration: 0.3,
      ease: 'power3.in',
    })
    .call(() => {
      if (window.lenis) {
        window.lenis.scrollTo(elementPosition, { immediate: true })
      } else {
        window.scrollTo({ top: elementPosition, behavior: 'instant' })
      }
      activeSection.value = sectionId
    })
    .to(
      '.navbar__flash-overlay',
      {
        opacity: 0,
        duration: 0.35,
        ease: 'power3.out',
      },
      '>+=0.08'
    )
    .call(() => {
      isFlashTransitioning.value = false
    })
}

// Función para hacer scroll suave a una sección
const scrollToSection = (sectionId) => {
  // Si no estamos en el home, navegar primero
  if (route.name !== 'home') {
    router.push({ name: 'home', query: { section: sectionId } })
    return
  }

  const element = document.getElementById(sectionId)
  if (!element) return

  // Calcular distancia entre sección actual y destino
  const currentIndex = sectionsOrder.indexOf(activeSection.value)
  const targetIndex = sectionsOrder.indexOf(sectionId)
  const distance =
    currentIndex === -1 || targetIndex === -1 ? 0 : Math.abs(targetIndex - currentIndex)

  // Secciones lejanas (3+): usar flash transition en vez de scroll largo
  if (distance >= 3) {
    flashToSection(sectionId, element)
    return
  }

  // Secciones cercanas: scroll suave con GSAP
  const elementPosition = element.offsetTop

  gsap.to(window, {
    scrollTo: { y: elementPosition, autoKill: false },
    duration: 2.5,
    ease: 'expo.out',
  })
}

// Watch para detectar query param 'section' al navegar desde otra página
watch(
  () => route.query.section,
  (newSection) => {
    if (newSection && route.name === 'home') {
      // Pequeño delay para asegurar que el DOM esté listo
      setTimeout(() => {
        scrollToSection(newSection)
        // Limpiar query param manteniendo el historial limpio
        router.replace({ query: null })
      }, 500)
    }
  },
  { immediate: true }
)

// Función para detectar qué sección está activa basada en el scroll
const detectActiveSection = () => {
  const sections = ['home', 'about', 'whatido', 'works', 'journey', 'footer']
  const navbarHeight = 64
  const scrollPosition = window.scrollY + navbarHeight + 200 // offset para mejor detección

  // Si estamos muy cerca del top, siempre mostrar home como activo
  if (window.scrollY < 100) {
    activeSection.value = 'home'
    return
  }

  // Buscar la sección activa de abajo hacia arriba
  for (let i = sections.length - 1; i >= 0; i--) {
    const element = document.getElementById(sections[i])
    if (element && element.offsetTop <= scrollPosition) {
      activeSection.value = sections[i]
      break
    }
  }
}

// Función para animar el SVG path con efecto de dibujo
// direction: 'down' = scroll hacia abajo, 'up' = scroll hacia arriba
const animateSVGPath = (elementId, shouldDraw, delay = 0, direction = 'down') => {
  const pathElement = document.querySelector(`${elementId} path`)
  if (!pathElement) return

  // Obtener la longitud total del path
  const pathLength = pathElement.getTotalLength()

  // Matar animaciones previas en este elemento
  gsap.killTweensOf(pathElement)

  if (shouldDraw) {
    if (direction === 'down') {
      // Scroll hacia abajo: el path entra desde el inicio (positivo a 0)
      gsap.fromTo(
        pathElement,
        {
          strokeDasharray: pathLength,
          strokeDashoffset: pathLength,
        },
        {
          strokeDashoffset: 0,
          duration: 0.5,
          delay: delay,
          ease: 'power3.out',
        }
      )
    } else {
      // Scroll hacia arriba: el path entra desde el final (negativo a 0)
      gsap.fromTo(
        pathElement,
        {
          strokeDasharray: pathLength,
          strokeDashoffset: -pathLength,
        },
        {
          strokeDashoffset: 0,
          duration: 0.5,
          delay: delay,
          ease: 'power3.out',
        }
      )
    }
  } else {
    if (direction === 'down') {
      // Scroll hacia abajo: el path sale por el final (0 a negativo)
      gsap.fromTo(
        pathElement,
        {
          strokeDasharray: pathLength,
          strokeDashoffset: 0,
        },
        {
          strokeDashoffset: -pathLength,
          duration: 0.35,
          delay: delay,
          ease: 'power3.in',
        }
      )
    } else {
      // Scroll hacia arriba: el path sale por el inicio (0 a positivo)
      gsap.fromTo(
        pathElement,
        {
          strokeDasharray: pathLength,
          strokeDashoffset: 0,
        },
        {
          strokeDashoffset: pathLength,
          duration: 0.35,
          delay: delay,
          ease: 'power3.in',
        }
      )
    }
  }
}

// Configuración de SVGs por sección
const svgConfig = [
  { section: 'about', id: '#element-about' },
  { section: 'whatido', id: '#element-whatido' },
  { section: 'works', id: '#element-works' },
  { section: 'journey', id: '#element-journey' },
  { section: 'footer', id: '#element-contact' },
]

// Watch para detectar cambios en la sección activa y animar los SVGs
watch(activeSection, (newSection, oldSection) => {
  const sections = svgConfig.map((s) => s.section)
  const newIndex = sections.indexOf(newSection)
  const oldIndex = sections.indexOf(oldSection)

  // Determinar dirección del scroll
  const direction = newIndex > oldIndex ? 'down' : 'up'

  // Si la nueva sección no está en la lista (ej: home), ocultar el activo
  if (newIndex === -1) {
    if (oldIndex !== -1) {
      animateSVGPath(svgConfig[oldIndex].id, false, 0, 'up')
    }
    return
  }

  // Ocultar el SVG anterior y mostrar el nuevo con la dirección correcta
  if (oldIndex !== -1) {
    animateSVGPath(svgConfig[oldIndex].id, false, 0, direction)
  }

  // El nuevo aparece con un pequeño delay para crear fluidez
  animateSVGPath(svgConfig[newIndex].id, true, 0.1, direction)
})

// Animación de entrada para los elementos del navbar
const prepareEntranceAnimation = () => {
  if (prefersReducedMotion) return

  // Configurar estado inicial de todos los elementos
  gsap.set('.navbar__brand', {
    opacity: 0,
  })

  gsap.set('.navbar__links li', {
    y: -30,
    opacity: 0,
    rotateX: -15,
  })

  gsap.set('.navbar__actions', {
    y: 30,
    opacity: 0,
  })

  gsap.set('.navbar__mobile-toggle', {
    scale: 0.5,
    opacity: 0,
  })

  // SVGs decorativos de las esquinas - Efecto de "revelado" simulando dibujo
  // Como los SVGs son formas cerradas (fill), el stroke dibuja línea doble.
  // Usamos clip-path para revelar el SVG a lo largo de su curva natural.
  const cornerPaths = document.querySelectorAll('.navbar__corner-detail path')
  cornerPaths.forEach((path) => {
    // Limpiamos los atributos de trazo que pusimos antes
    gsap.set(path, {
      strokeDasharray: 'none',
      strokeDashoffset: 0,
      fillOpacity: 1,
      stroke: 'none',
    })
  })

  // Ocultamos el contenedor con un clip-path circular
  // Mantenemos la opacidad original de CSS (0.18)

  // --top va de abajo hacia arriba (empieza en la esquina inferior izquierda)
  gsap.set('.navbar__corner-detail.--top', {
    clipPath: 'circle(0% at 0% 100%)',
  })

  // el otro va de arriba hacia abajo (empieza en la esquina superior derecha)
  gsap.set('.navbar__corner-detail:not(.--top)', {
    clipPath: 'circle(0% at 100% 0%)',
  })
}

const playEntranceAnimation = () => {
  if (prefersReducedMotion) return

  const tl = gsap.timeline({
    defaults: {
      ease: 'power4.out',
    },
  })

  // Timeline de animación
  tl
    // Logo aparece con un fade simple
    .to('.navbar__brand', {
      opacity: 1,
      duration: 0.8,
      ease: 'power2.inOut',
    })

    // Links del nav aparecen en cascada desde arriba
    .to(
      '.navbar__links li',
      {
        y: 0,
        opacity: 1,
        rotateX: 0,
        duration: 0.6,
        stagger: 0.08,
        ease: 'back.out(1.2)',
      },
      '-=0.5' // Overlap con la animación anterior
    )

    // Acciones aparecen desde abajo
    .to(
      '.navbar__actions',
      {
        y: 0,
        opacity: 1,
        duration: 0.6,
        ease: 'back.out(1.3)',
      },
      '-=0.4'
    )

    // Botón móvil aparece con scale
    .to(
      '.navbar__mobile-toggle',
      {
        scale: 1,
        opacity: 1,
        duration: 0.5,
        ease: 'back.out(2)',
      },
      '-=0.5'
    )

    // Revelado fluido de las esquinas (efecto de dibujo en direcciones opuestas)
    .to(
      '.navbar__corner-detail.--top',
      {
        clipPath: 'circle(150% at 0% 100%)',
        duration: 1.8,
        ease: 'power3.inOut',
      },
      '-=0.6'
    )
    .to(
      '.navbar__corner-detail:not(.--top)',
      {
        clipPath: 'circle(150% at 100% 0%)',
        duration: 1.8,
        ease: 'power3.inOut',
      },
      '<0.2'
    )
}

onMounted(() => {
  // Solo agregar el listener si estamos en la página home
  if (route.path === '/') {
    window.addEventListener('scroll', detectActiveSection)
    detectActiveSection() // Detectar sección inicial

    // Ejecutar animación de entrada
    nextTick(() => {
      prepareEntranceAnimation()
      if (window.__PRELOADER_ALL_DONE__ || !document.querySelector('.preloader')) {
        playEntranceAnimation()
      } else {
        window.addEventListener('preloader:all-done', playEntranceAnimation, { once: true })
      }
    })

    // Inicializar los SVG paths con el dashoffset
    nextTick(() => {
      const svgElements = [
        '#element-about',
        '#element-whatido',
        '#element-works',
        '#element-journey',
        '#element-contact',
      ]
      svgElements.forEach((selector) => {
        const pathElement = document.querySelector(`${selector} path`)
        if (pathElement) {
          const pathLength = pathElement.getTotalLength()
          pathElement.style.strokeDasharray = pathLength
          pathElement.style.strokeDashoffset = pathLength
        }
      })
    })
  }
})

onUnmounted(() => {
  window.removeEventListener('scroll', detectActiveSection)
  document.body.style.overflow = ''

  // Limpiar contenedor de chispas
  if (sparkContainer && sparkContainer.parentNode) {
    sparkContainer.remove()
    sparkContainer = null
  }
})
</script>

<style scoped>
/* ==========================================================================
   NAVBAR V2 - Layout con elementos posicionados absolutamente
   ========================================================================== */

/* Wrapper principal - no bloquea interacciones */
.navbar-wrapper {
  @apply fixed inset-0 z-50 pointer-events-none;
}

/* ==========================================================================
   BRAND / LOGO - Arriba izquierda
   ========================================================================== */
.navbar__brand {
  @apply absolute top-6 left-6 md:left-12 lg:left-16 cursor-pointer transition-transform duration-200 hover:scale-105 pointer-events-auto;
}

.navbar__brand-name {
  @apply font-madi text-3xl md:text-4xl tracking-wide text-text-primary transition-colors duration-300;
}

.navbar__brand--active .navbar__brand-name {
  @apply text-electric-purple;
}

/* ==========================================================================
   NAV - Links centrados verticalmente a la derecha
   ========================================================================== */
.navbar {
  @apply hidden lg:flex absolute right-4 md:right-12 lg:right-16 top-8 pointer-events-auto;
  transition: opacity 0.5s ease;
}

.navbar--dimmed {
  opacity: 0.2;
}

.navbar--dimmed:hover {
  opacity: 1;
}

.navbar__links {
  @apply flex flex-col items-end gap-4 text-sm font-medium text-text-secondary relative list-none m-0 p-0;
}

.navbar__links .element {
  @apply absolute -left-5;
}

.navbar__link {
  @apply cursor-pointer transition-colors duration-300 hover:text-electric-purple relative;
}

/* SVG decorativo para el link activo */
.navbar__link-svg {
  @apply absolute pointer-events-none text-electric-purple;
  /* transform: scale(.6); */
  /* transform: translateY(-50%) translateX(-100%); */
}

/* #element-about { */
.aaa {
  top: 10px;
  left: -17px;
}

#element-whatido {
  top: -10.4px;
  right: -18px;
}

#element-works {
  top: -11px;
  left: -38px;
}

#element-journey {
  top: -12px;
  right: -16px;
}

#element-contact {
  top: -13.4px;
  left: -17px;
}

/* SVG posicionado a la derecha (para what i do) */
.navbar__link-svg--right {
  left: auto;
  top: -6.4px;
  right: -26.5px;
}

.navbar__link-svg path {
  stroke-linecap: round;
  stroke-linejoin: round;
}

.navbar__link::after {
  content: '';
  @apply absolute -bottom-1 right-0 w-0 h-0.5 bg-electric-purple transition-all duration-300;
}

/* Hover effect handled via svg or other means now */

.navbar__link--active {
  @apply text-electric-purple font-bold;
}

.navbar__corner-detail {
  @apply hidden lg:block;
  position: fixed;
  bottom: 0;
  right: 0;
  width: 310px;
  height: auto;
  color: var(--color-text-primary) !important;
  pointer-events: none;
  user-select: none;
  -webkit-user-drag: none;
  z-index: 10;
  opacity: 0.18;
}

.navbar__corner-detail.--top {
  top: 0;
  left: 0;
}

/* ==========================================================================
   ACCIONES - Abajo derecha
   ========================================================================== */
.navbar__actions {
  @apply hidden lg:flex items-center gap-3 absolute bottom-6 right-6 md:right-12 lg:right-16 pointer-events-auto;
}

/* ==========================================================================
   BOTONES
   ========================================================================== */
.navbar__button {
  @apply flex items-center gap-2 px-4 py-2 border-2 border-border rounded-full text-base font-medium text-text-secondary bg-transparent transition-all duration-200 cursor-pointer hover:bg-surface-elevated hover:border-electric-purple hover:text-text-primary;
}

.navbar__button--large {
  @apply gap-2 px-4 py-2 text-lg;
}

/* ==========================================================================
   ICONOS
   ========================================================================== */
.navbar__icon {
  @apply w-5 h-5;
}

.navbar__icon--large {
  @apply w-6 h-6;
}

.navbar__icon-btn {
  @apply flex items-center justify-center p-2;
  @apply border-2 border-border text-text-secondary;
  @apply transition-all duration-200 cursor-pointer overflow-hidden;
  @apply bg-transparent hover:border-electric-purple hover:text-text-primary backdrop-blur-sm;
}

.navbar__icon-btn--round {
  @apply rounded-full w-11 h-11;
}

.navbar__icon-btn--large {
  @apply w-12 h-12 p-2;
}

/* ==========================================================================
   MOBILE TOGGLE
   ========================================================================== */
.navbar__mobile-toggle {
  @apply lg:hidden z-[70] p-2;
  @apply absolute top-4 right-6;
  @apply text-text-secondary rounded-full bg-transparent backdrop-blur-sm border-none;
  @apply transition-all duration-200 cursor-pointer;
  @apply hover:bg-transparent hover:text-text-primary;
  @apply pointer-events-auto;
}

/* ==========================================================================
   MOBILE MENU
   ========================================================================== */
.mobile-menu {
  @apply fixed inset-0 z-[60];
  @apply flex flex-col items-center justify-center;
  @apply bg-deep-black backdrop-blur-3xl;
  @apply pointer-events-auto;
  clip-path: circle(0% at 100% 0%);
}

/* Light mode - CSS puro porque :root selector no funciona bien con @apply */
:root:not(.dark) .mobile-menu {
  background-color: rgba(248, 250, 252, 0.95);
}

.mobile-menu__links {
  @apply flex flex-col items-center gap-8;
  @apply text-3xl font-medium text-text-secondary;
}

.mobile-menu__link {
  @apply cursor-pointer transition-colors duration-300 hover:text-electric-purple;
}

.mobile-menu__actions {
  @apply mt-12 flex flex-col items-center gap-8;
}

.mobile-menu__link--active {
  @apply text-electric-purple font-bold;
}

/* Mobile Language Switcher */
.mobile-lang-switcher {
  @apply flex items-center gap-4 p-1 rounded-full border border-border bg-surface-elevated;
}

.mobile-lang-btn {
  @apply px-4 py-2 rounded-full text-sm font-medium text-text-secondary transition-all duration-300;
  @apply hover:text-text-primary hover:bg-white/5;
}

.mobile-lang-btn--active {
  @apply bg-electric-purple text-white shadow-lg;
  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);
}

/* Mobile Footer */
.mobile-menu__footer {
  @apply absolute bottom-8 left-0 right-0 flex flex-col items-center gap-2;
  @apply text-xs tracking-wider opacity-60;
}

.mobile-menu__version {
  @apply font-mono text-[var(--color-text-muted)];
}

.mobile-menu__copy {
  @apply uppercase font-medium text-[var(--color-text-muted)];
}

/* ==========================================================================
   FLASH TRANSITION OVERLAY
   ========================================================================== */
.navbar__flash-overlay {
  @apply fixed inset-0 pointer-events-none opacity-0 z-[49];
  background-color: var(--color-deep-black);
}
</style>
